import { CircularProgress, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import useStyles from './useStyles'

import { useDispatch } from 'react-redux'
import { getOrganizationWithID } from '../../../../redux/actions/Organizations'

export const BoxOrganization = ({ item = null }) => {
  const classes = useStyles()
  const [org, setorg] = useState(null)
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()

  const getOrg = async () => {
    setLoading(true)
    const response = await dispatch(getOrganizationWithID(item.organizationId))
    setorg(response)
  }

  useEffect(async () => {
    if (item) {
      setLoading(true)
      await getOrg()
      setLoading(false)
    }
  }, [item])

  if (loading) {
    return (
      <Grid container className={classes.boxDetails}>
        <Grid item xs={12}>
          <Typography
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              color: '#4B4952',
              paddingLeft: 10,
              borderBottom: '1px solid rgba(36, 55, 143, 0.2)'
            }}
          >
            Organización asociada
          </Typography>
        </Grid>
        <Grid
          container
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <CircularProgress color="success" />
        </Grid>
      </Grid>
    )
  }
  if (!org) {
    return (
      <Grid container className={classes.boxDetails}>
        <Grid item xs={12}>
          <Typography
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              color: '#4B4952',
              paddingLeft: 10,
              borderBottom: '1px solid rgba(36, 55, 143, 0.2)'
            }}
          >
            Organización asociada
          </Typography>
        </Grid>
        <Grid
          container
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Typography
            style={{
              fontSize: 14,
              fontWeight: 'bold',
              color: '#485450'
            }}
          >
            No se encontró la organización asociada
          </Typography>
        </Grid>
      </Grid>
    )
  }
  return (
    org && (
      <Grid container className={classes.boxDetails}>
        <Grid item xs={12}>
          <Typography
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              color: '#4B4952',
              paddingLeft: 10,
              borderBottom: '1px solid rgba(36, 55, 143, 0.2)'
            }}
          >
            Organización asociada
          </Typography>
        </Grid>
        <Grid container style={{ padding: 10 }}>
          <Grid item xs={4}>
            <Typography
              style={{
                fontSize: 15,
                fontWeight: 'bold',
                color: '#485450'
              }}
            >
              Nombre:
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography
              style={{
                fontSize: 15,
                fontWeight: 'bold',
                color: '#6e7a76'
              }}
            >
              {org.organizationName}
            </Typography>
          </Grid>

          <Grid item xs={4}>
            <Typography
              style={{
                fontSize: 15,
                fontWeight: 'bold',
                color: '#485450'
              }}
            >
              CUIT:
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography
              style={{
                fontSize: 15,
                fontWeight: 'bold',
                color: '#6e7a76'
              }}
            >
              {org.organizationCuit}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    )
  )
}
